import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useTranslation } from 'react-i18next';
import useCompanyDocumentCategory from '../useCompanyDocumentCategory';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';
import { useCallback } from 'react';

const CompanyCategoriesDocumentMainPage = () => {
  const { t } = useTranslation();
  const { columns, data, onChangeTableFilter, loading, handleDeleteCategory } =
    useCompanyDocumentCategory();
  const pages = useRecoilValue(getPage);
  const navigate = useNavigate();

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  return (
    <div>
      <PageHeader title={t('CATEGORIE DOCUMENTI').toUpperCase()}>
        {pages?.ability?.can_create && (
          <Link to={'new'}>
            <Button width={'138px'} big icon={<PlusOutlined />}>
              {t('NUOVO')}
            </Button>
          </Link>
        )}
      </PageHeader>
      <div className={styles.container}>
        <Table
          className={styles.table}
          columns={columns}
          dataSource={data.company_document_categories}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          onRow={handleOnRow}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal
              onClickDelete={handleDeleteCategory}
              loading={loading}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default CompanyCategoriesDocumentMainPage;
